import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HelpersService } from '../../../../../../services';
import { PosIntegrationService } from '../../../../../../services/pos-integration.service';

@Component({
  selector: 'app-callback-square',
  templateUrl: './callback-square.component.html',
  styleUrls: ['./callback-square.component.scss'],
})
export class CallbackSquareComponent implements OnInit {
  private code: string = '';
  private company: string = '';

  constructor(
    private route: ActivatedRoute,
    private posIntegrationService: PosIntegrationService,
    public helpersService: HelpersService,
  ) {}

  ngOnInit() {
    var partnerData = this.helpersService.getPartnerData();
    console.log(this.route);
    this.code = this.route.snapshot.queryParams['code'];
    this.company = this.route.snapshot.paramMap.get('company');

    this.code = this.code == null ? '' : this.code;
    this.company = this.company == null ? '' : this.company;

    console.log(this.code, this.company);

    if (this.code != '') {
      if (partnerData != undefined) {
        this.posIntegrationService
          .ProcessCallbacks(partnerData.ID, this.code, 'square')
          .subscribe((res) => {
            console.log(res, 'result');
            window.close();
          });
      } else {
        this.posIntegrationService
          .ProcessCallbacks(0, this.code, 'square')
          .subscribe((res) => {
            console.log(res, 'result');
            window.close();
          });
      }
    } else {
      console.log('oops');
    }
  }
}
